import { FIELD_TYPES } from '@/common-utils/components/renders/detailsGrid/FieldTypes';
import { FILTER_TYPES } from '@/common-utils/components/renders/dataTable/filter/FilterTypes';
import { RENTAL_FILE_STATUS } from '../enum/RentalFileStatus';
import { nsRentalFile } from '@/app/i18n/namespaces';

const rentalFilesFields = {
    UUID: {
        key: 'uuid'
    },
    FILE_NUMBER: {
        key: 'fileNumber',
        type: FIELD_TYPES.TEXT,
        entity: 'keys.file_number',
        namespace: nsRentalFile,
        filter: FILTER_TYPES.INPUT,
        placeholder: 'filter.placeholder.file_number'
    },
    POS_TERMINAL: {
        key: 'posTerminal',
        LABEL: {
            parentKeys: ['posTerminal'],
            key: 'label',
            type: FIELD_TYPES.TEXT,
            entity: 'keys.label',
            namespace: nsRentalFile,
            filter: FILTER_TYPES.INPUT,
            placeholder: 'filter.placeholder.label',
            isLongText: true,
            isNested: true
        }
    },
    TOTAL_AMOUNT: {
        key: 'totalAmount',
        type: FIELD_TYPES.AMOUNT,
        entity: 'keys.total_amount',
        filter: FILTER_TYPES.NUMBER,
        namespace: nsRentalFile
    },
    CURRENCY: {
        key: 'currency',
        type: FIELD_TYPES.TEXT,
        entity: 'keys.currency',
        namespace: nsRentalFile
    },
    CONTRACT: {
        key: 'contract',
        type: FIELD_TYPES.TEXT,
        entity: 'keys.contract',
        namespace: nsRentalFile
    },
    STATUS: {
        key: 'status',
        type: FIELD_TYPES.BADGE,
        entity: 'keys.status',
        namespace: nsRentalFile,
        filter: FILTER_TYPES.SELECT,
        enum: RENTAL_FILE_STATUS
    },
    BANK_CODE: {
        key: 'bankCode',
        type: FIELD_TYPES.TEXT,
        entity: 'keys.bank_code',
        namespace: nsRentalFile
    },
    PAN: {
        key: 'pan',
        type: FIELD_TYPES.TEXT,
        entity: 'keys.pan',
        namespace: nsRentalFile,
        filter: FILTER_TYPES.INPUT,
        placeholder: 'filter.placeholder.pan'
    },
    OPENING_DATE: {
        key: 'openingDate',
        type: FIELD_TYPES.DATE_TIME_SHORT,
        entity: 'keys.opening_date',
        namespace: nsRentalFile,
        filter: FILTER_TYPES.DATE
    },
    CLOSING_DATE: {
        key: 'closingDate',
        type: FIELD_TYPES.DATE_TIME_SHORT,
        entity: 'keys.closing_date',
        namespace: nsRentalFile,
        filter: FILTER_TYPES.DATE
    },
    EXPIRATION_DATE: {
        key: 'expirationDate',
        type: FIELD_TYPES.DATE,
        entity: 'keys.expiration_date',
        namespace: nsRentalFile,
        filter: FILTER_TYPES.DATE
    },
    CARD_DETAILS: {
        key: 'cardDetails',
        TYPE: {
            parentKeys: ['cardDetails'],
            key: 'type',
            type: FIELD_TYPES.TEXT,
            entity: 'keys.card_type',
            namespace: nsRentalFile,
            filter: FILTER_TYPES.INPUT,
            placeholder: 'filter.placeholder.card_type'
        },
        PRODUCT: {
            parentKeys: ['cardDetails'],
            key: 'product',
            type: FIELD_TYPES.TEXT,
            entity: 'keys.card_product',
            namespace: nsRentalFile
        }
    },
    RANK: {
        key: 'rank',
        type: FIELD_TYPES.TEXT,
        entity: 'keys.rank',
        namespace: nsRentalFile,
        filter: FILTER_TYPES.INPUT
    },
    RENTAL_EVENTS: {
        key: 'rentalEvents',
        UUID: {
            parentKeys: ['rentalEvents'],
            key: 'uuid'
        },
        LOCAL_TRANSACTION_DATE_TIME: {
            parentKeys: ['rentalEvents'],
            key: 'localTransactionDateTime'
        },
        EVENT_TYPE: {
            parentKeys: ['rentalEvents'],
            key: 'eventType'
        },
        CREATED_AT: {
            parentKeys: ['rentalEvents'],
            key: 'createdAt'
        },
        AMOUNT: {
            parentKeys: ['rentalEvents'],
            key: 'amount'
        },
        CURRENCY: {
            parentKeys: ['rentalEvents'],
            key: 'currency'
        },
        TRANSACTION_TYPE: {
            parentKeys: ['rentalEvents'],
            key: 'transactionType'
        },
        AUTHORIZATION_CODE: {
            parentKeys: ['rentalEvents'],
            key: 'authorizationCode'
        }
    },
    INITIAL_AMOUNT: {
        key: 'initialAmount',
        type: FIELD_TYPES.AMOUNT,
        entity: 'keys.initial_amount',
        namespace: nsRentalFile
    },
    FINAL_AMOUNT: {
        key: 'finalAmount',
        type: FIELD_TYPES.AMOUNT,
        entity: 'keys.final_amount',
        namespace: nsRentalFile
    }
};

export default rentalFilesFields;